import { render, staticRenderFns } from "./RetailerTips.vue?vue&type=template&id=45d9f2b2&"
import script from "./RetailerTips.vue?vue&type=script&lang=js&"
export * from "./RetailerTips.vue?vue&type=script&lang=js&"
import style0 from "./RetailerTips.vue?vue&type=style&index=0&id=45d9f2b2&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports